import { cx } from "@frontend/components/ui";
import { branding } from "@creators/backend/lib/config";

/**
 * SendCollab mark — chevrons only (no tile). Colours from `--brand-mark-*`.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="24 32 88 64"
      className={cx("shrink-0", className)}
      aria-hidden="true"
      focusable="false"
    >
      <polyline
        points="32,45 50,64 32,83"
        fill="none"
        stroke="var(--brand-mark-chevron-1)"
        strokeWidth="7.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="55.5,42.5 76.5,64 55.5,85.5"
        fill="none"
        stroke="var(--brand-mark-chevron-2)"
        strokeWidth="8.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="79,39.5 103,64 79,88.5"
        fill="none"
        stroke="var(--brand-mark-chevron-3)"
        strokeWidth="9.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Mark + wordmark for nav / footer / auth. */
export function BrandLogo({
  className,
  markClassName,
  showWordmark = true,
  /** When true, wordmark stays visible on small screens (footer). */
  wordmarkAlways = false,
}: {
  className?: string;
  markClassName?: string;
  showWordmark?: boolean;
  wordmarkAlways?: boolean;
}) {
  return (
    <span className={cx("inline-flex items-center gap-2 font-medium tracking-tight", className)}>
      <BrandMark className={cx("h-5 w-[1.7rem]", markClassName)} />
      {showWordmark ? (
        <span
          className={cx(
            "text-[1.05rem] text-ink",
            wordmarkAlways ? "inline" : "hidden sm:inline",
          )}
        >
          {branding.name}
        </span>
      ) : null}
    </span>
  );
}
